module.exports = __webpack_public_path__ + "img/language2.c80728f0.svg";